/**
 * ts-main-style Footer for fleet-doctor.
 * Simple footer matching ts-main's minimal design.
 */
export default function Footer() {
  return (
    <footer className="bg-white border-t border-slate-200 py-3 px-4 text-center flex-shrink-0">
      <div className="flex items-center justify-center gap-2 text-xs text-slate-400">
        <span className="font-semibold text-slate-500">Fleet Command Center</span>
        <span>•</span>
        <span>Operational Intelligence Platform</span>
        <span>•</span>
        <span>v2.0</span>
      </div>
    </footer>
  )
}
